import { createReducer } from '@lib/plugin-redux-core';
import {
  CHANGE_TEST_MAKER_LOCALE_USE_CASE,
  GET_TEST_MAKER_LOCALE_USE_CASE,
  GET_USER_BY_ID_USE_CASE,
  SIGN_OUT_USE_CASE,
  User,
} from '@module/user';
import { UseCaseError } from '@digibricks/core';
import {
  handleChangeTestMakerLocaleUseCase,
  handleGetTestMakerLocaleUseCase,
  handleSignOutUseCase,
} from './layout.handler';
import { handleGetUserByIdUseCase } from './layout.handler';

export const enum PageLayoutStatus {
  EXECUTE = 1,
  SUCCESS = 2,
  ERROR = 3,
  RESET = 4,
}

export type PageLayoutInitialState = {
  error?: UseCaseError<any>;
};

export type GetUserByIdUseCaseType = {
  userResponse: User;
  getUserByIdStatus: PageLayoutStatus;
};

export type SignOutUseCaseType = {
  signOutStatus: PageLayoutStatus;
};

export type GetTestMakerLocaleUseCaseType = {
  currentLocale: string | null;
  getTestMakerLocaleStatus: PageLayoutStatus;
};

export type ChangeTestMakerLocaleUseCaseType = {
  changeTestMakerLocaleStatus: PageLayoutStatus;
};

export type PageLayoutState = PageLayoutInitialState &
  GetUserByIdUseCaseType &
  SignOutUseCaseType &
  GetTestMakerLocaleUseCaseType &
  ChangeTestMakerLocaleUseCaseType;

const initialState: PageLayoutInitialState = {
  error: null,
};

export const pageLayoutReducer = createReducer(initialState, [
  {
    name: SIGN_OUT_USE_CASE,
    ...handleSignOutUseCase,
  },
  {
    name: GET_USER_BY_ID_USE_CASE,
    ...handleGetUserByIdUseCase,
  },
  {
    name: GET_TEST_MAKER_LOCALE_USE_CASE,
    ...handleGetTestMakerLocaleUseCase,
  },
  {
    name: CHANGE_TEST_MAKER_LOCALE_USE_CASE,
    ...handleChangeTestMakerLocaleUseCase,
  },
]);
